module.exports = __webpack_public_path__ + "img/logo-136538.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/login/logo.png
// module id = 802
// module chunks = 0